/**
 * Сервис для работы с кастомными колонками товаров
 */
import apiService from './apiService'

export default {
  /**
   * Получить список всех кастомных колонок
   * @param {boolean} includeInactive - Включить неактивные колонки
   * @returns {Promise<{items: Array, total: number}>}
   */
  async getAll(includeInactive = false) {
    const response = await apiService.get('/admin/custom-columns', {
      params: { include_inactive: includeInactive }
    })
    return response.data
  },

  /**
   * Создать новую кастомную колонку
   * @param {Object} columnData - Данные колонки
   * @returns {Promise<Object>}
   */
  async create(columnData) {
    const response = await apiService.post('/admin/custom-columns', columnData)
    return response.data
  },

  /**
   * Обновить кастомную колонку
   * @param {number} id - ID колонки
   * @param {Object} columnData - Данные для обновления
   * @returns {Promise<Object>}
   */
  async update(id, columnData) {
    const response = await apiService.put(`/admin/custom-columns/${id}`, columnData)
    return response.data
  },

  /**
   * Удалить кастомную колонку
   * @param {number} id - ID колонки
   * @returns {Promise<void>}
   */
  async delete(id) {
    await apiService.delete(`/admin/custom-columns/${id}`)
  },

  /**
   * Получить полную схему товара (нативные + кастомные поля)
   * @returns {Promise<{native_fields: Array, custom_fields: Array, total_fields: number}>}
   */
  async getProductSchema() {
    const response = await apiService.get('/products/schema')
    return response.data
  },

  /**
   * Получить список колонок для маппинга Excel
   * @returns {Promise<{columns: Array, total: number}>}
   */
  async getColumnsForMapping() {
    const response = await apiService.get('/products/columns')
    return response.data
  }
}
